<template>
  <div class="text-center">
    <div class="title title--sm">
      <h1>Связаться с нами</h1>
      <p>Вы можете написать нам в любой мессенджер, отправить письмо на электронную почту, даже позвонить. Ну или оставить заявку в форме ниже. Мы будем рады проконсультировать вас и помочь вашему проекту.</p>
    </div>
      <div class="container">
        <div class="block-center">
          <div class="contacts__sub">Контакты</div>
          <ul class="contacts__data">
            <li>
              <a href="mailto:sales@giveandgo.ru">sales@giveandgo.ru</a>
            </li>
            <li>
              <a href="tel:+79062106621">+7 906 21 066 21</a><span> (Whatsapp, Telegram, Viber)</span>
            </li>
          </ul>
          <Feedback />
        </div>
      </div>
  </div>
</template>
<script>
const name = 'Contact'
import Feedback from '@/components/Feedback.vue'


export default {
  name,
  components: {
    Feedback
  }
}

</script>
